<template>
  <div>
    <h3>Página no encontrada</h3>
  </div>
</template>
<script>
export default {};
</script>
